import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_long",
  "use": "arrow_long-usage",
  "viewBox": "0 0 14 10",
  "content": "<symbol viewBox=\"0 0 14 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow_long\">\n<path d=\"M5 1L1 5L5 9\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M13.5 5.5C13.7761 5.5 14 5.27614 14 5C14 4.72386 13.7761 4.5 13.5 4.5V5.5ZM1 5.5H13.5V4.5H1V5.5Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol